// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._12l21wug{margin-inline-end:auto}\n._1pfhoahv{margin-block-start:var(--ds-space-600,3pc)}\n._6rthoahv{margin-block-end:var(--ds-space-600,3pc)}\n._ahbq1wug{margin-inline-start:auto}\n._p12f1pl1{max-width:29pc}\n._p12fko4j{max-width:19pc}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
